import { ISubscriptionItem } from "./types";

export enum Types {
    SET_MY_SUBSCRIPTIONS = "SET_MY_SUBSCRIPTIONS",
}

export const SetMySubscriptions = (subscriptions: ISubscriptionItem[]|undefined,callback?:any) => {
    return {
        type: Types.SET_MY_SUBSCRIPTIONS,
        data: {
            subscriptions,
            callback
        }
    };
};